import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "../../common/Button"

import classes from './Exceptions.module.css'
import OutsideClickComponent from "../../fragments/OutsideClickComponent"
import { retriveAllCaseFlags } from "../../../lib/systemData"
import { filterActions } from "../../../store/filter"
import ExceptionsGroup from "./ExceptionsGroup"
import { workqueueActions } from "../../../store/workqueue"
import { objectHasOwnProperty } from "../../../lib/script"
import { miscellaneous } from "../../../lib/misc"
import TotalExceptions from "./TotalExceptions"

/**
 * Build exception groups for the modal: prefer API ordered list, else case_flags config.
 * Shape: [{ group, filters: [{ key, label, details? }] }]
 */
function buildExceptionGroupsForWorkQ(workQ) {
    const caseFlags = retriveAllCaseFlags() || []
    const detailsByKey = {}
    caseFlags.forEach((group) => {
        ;(group.filters || []).forEach((filter) => {
            if (filter?.key) {
                detailsByKey[filter.key] = filter
            }
        })
    })

    const ordered = workQ?.exceptions_filter_groups
    if (Array.isArray(ordered) && ordered.length > 0) {
        const groupNameArray = []
        ordered.forEach((element) => {
            if (element?.group && !groupNameArray.includes(element.group)) {
                groupNameArray.push(element.group)
            }
        })

        return groupNameArray.map((groupName) => ({
            group: groupName,
            filters: ordered
                .filter((entry) => entry.group === groupName)
                .map((entry) => ({
                    ...(detailsByKey[entry.key] || {}),
                    key: entry.key,
                    label: entry.label || detailsByKey[entry.key]?.label || entry.key,
                })),
        }))
    }

    if (!caseFlags.length || !workQ?.exceptions_filters) {
        return []
    }

    return caseFlags
        .map((item) => ({
            ...item,
            filters: (item.filters || []).filter((elem) =>
                objectHasOwnProperty(workQ.exceptions_filters, elem.key)
            ),
        }))
        .filter((item) => item.filters.length > 0)
}

export default function Exceptions({workQ}) {
    const dispatch = useDispatch()
    const selectedExceptions = useSelector(state => state.filter.exceptions)

    const [showModal, setShowModal] = useState(false)
    const [exceptionValues, setExceptionValues] = useState(null)

    const exceptionGroups = useMemo(
        () => buildExceptionGroupsForWorkQ(workQ),
        [workQ]
    )

    useEffect(() => {
        setExceptionValues(selectedExceptions)
    }, [selectedExceptions])

    function openModalHandler() {
        setShowModal(true)
    }
    function closeModalHandler() {
        setShowModal(false)
        setExceptionValues(selectedExceptions)        
    }

    function selectCheckBoxHandler(value) {
        let updateobject = {
            ...exceptionValues
        }
        let update = JSON.parse(JSON.stringify(updateobject))
        
        if (update?.case_flags) {
            if (value.data.value) {
                update.case_flags[value.identifier.type] = value.data.value
            } else {
                delete update.case_flags[value.identifier.type]
            }
        } else {
            if (value.data.value) {
                update.case_flags = {
                    [value.identifier.type] : value.data.value
                }
            } else {
                delete update.case_flags[value.identifier.type]
            }
            
        }
        setExceptionValues(update)
        
    }

    function selectAllHandler(value) {
        let updateobject = {
            ...exceptionValues
        }
        let update = JSON.parse(JSON.stringify(updateobject))

        const group = exceptionGroups.find(item => item.group == value.identifier.type)
        if (group && group.filters) {
            group.filters.forEach(element => {
                if (update?.case_flags) {
                    update.case_flags[element.key] = value.data.value
                } else {
                    update.case_flags = {
                        [element.key] : value.data.value
                    }
                }
            });
        }

        setExceptionValues(update)
    }

    async function setFiltersHandler(event) {
        dispatch(filterActions.setExceptionsBatch(exceptionValues))
        dispatch(filterActions.setCurrentPage(1))
        dispatch(workqueueActions.setRefreshApi())
        
        setShowModal(false)
    }

    function totalExceptionsNumber() {
        let number = 0
        if (workQ && workQ.exceptions_filters) {
            number = miscellaneous.numberOfObjectValues(workQ.exceptions_filters)
        }

        if (exceptionValues && exceptionValues.case_flags && Object.keys(exceptionValues?.case_flags).length) {   
            for (const [key, value] of Object.entries(exceptionValues?.case_flags)) {   
                if (workQ && workQ.exceptions_filters) {
                    if (workQ.exceptions_filters[key]) {                    
                        if (!value) {
                            number = number - 1
                        }
                    } else {
                        if (value) {
                            number = number + 1
                        }
                    }
                }
            }
        }
        return number
    }

    return <>
        <div className={classes.master_filter}>
            <Button click={openModalHandler} isDisabled={showModal} bypassisCaseArchived={true} btnStyle={'btn_dark'}>
                Exceptions

                {totalExceptionsNumber() > 0 && (
                    <span className={classes.total_exceptions_number} onClick={openModalHandler}>
                        <TotalExceptions />
                    </span>
                )}
           
            </Button>

            {showModal && <OutsideClickComponent task={closeModalHandler}>
                <div className={classes.container}>
                    <div>
                        <div className={classes.container_header}>
                            <div>Exceptions</div>                        
                        </div>
                        <div className={classes.container_fields_wrapper}>
                            <div className={classes.container_fields}>
                                {exceptionGroups.map(item => (
                                    <ExceptionsGroup key={item.group} item={item} exceptionValues={exceptionValues} selectCheckBoxHandler={selectCheckBoxHandler} selectAllHandler={selectAllHandler} workQ={workQ}/>
                                ))}
                            </div>
                        </div>
                        <div className={classes.filter_footer}>
                            <Button click={setFiltersHandler}>Set Filters</Button>
                        </div>
                    </div>
                </div>
            </OutsideClickComponent>}
        </div>
    </>
}
